import { useEffect } from 'react'
import { CheckCircle2, XCircle, Info, X } from 'lucide-react'
import { useToastStore, type Toast } from '@/stores/toastStore'
import { cn } from '@/lib/cn'

const ICON = { success: CheckCircle2, error: XCircle, info: Info }
const TONE = {
  success: 'border-success/30 text-success',
  error: 'border-danger/30 text-danger',
  info: 'border-primary/30 text-primary',
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[min(92vw,380px)] flex-col gap-2">
      {toasts.map((t) => (
        <ToastCard key={t.id} toast={t} />
      ))}
    </div>
  )
}

function ToastCard({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss)
  const Icon = ICON[toast.type]
  useEffect(() => {
    const t = setTimeout(() => dismiss(toast.id), 4000)
    return () => clearTimeout(t)
  }, [toast.id, dismiss])
  return (
    <div className={cn('pointer-events-auto flex items-start gap-3 rounded-md border bg-white px-4 py-3 shadow-pop', TONE[toast.type])}>
      <Icon size={18} className="mt-0.5 flex-none" />
      <p className="flex-1 text-title-sm font-medium text-slate-700">{toast.message}</p>
      <button onClick={() => dismiss(toast.id)} className="text-slate-400 hover:text-slate-600" aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  )
}
